import React from "react";
import Forms from "./contact/Forms";
import Details from "./contact/Details";
import "./styles/contact.sass";

const Contact = () => {
  return (
    <div className='contact'>
      <h3>Kontakt</h3>
      <div className='wrap'>
        <Forms />
        <Details />
      </div>
    </div>
  );
};

export default Contact;
